import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import sponsor from "@/assets/sponsor-band.webp";

export function SponsorBand() {
  return (
    <section className="relative overflow-hidden">
      <img
        src={sponsor}
        alt=""
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/80 to-primary/40" />
      <div className="container relative mx-auto grid items-center gap-10 px-4 py-24 md:grid-cols-2">
        <div className="text-primary-foreground">
          <span className="text-sm font-semibold uppercase tracking-widest text-accent">
            Sponsor a project
          </span>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-tight md:text-5xl text-balance">
            Fund an entire project from start to finish
          </h2>
          <p className="mt-4 max-w-lg text-primary-foreground/85">
            Want to make a deep, lasting impact? Sponsor an entire project — a
            school refurbishment, a family home, a medical fund — and follow it
            from inception to closure with full transparency.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button asChild size="lg" variant="secondary" className="rounded-full">
              <Link to="/sponsor">Browse projects to sponsor</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full bg-transparent text-primary-foreground border-primary-foreground/40 hover:bg-primary-foreground hover:text-primary">
              <Link to="/contact">Talk to our team</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
